import axios from "axios"

const API_BASE = 'https://api.h2.damine.com.br'

const TOKEN_KEY = 'greenfuel_access_token'
const REFRESH_KEY = 'greenfuel_refresh_token'
const USER_KEY = 'greenfuel_username'

export const login = async (username: string, password: string) => {
    const response = await axios.post(`${API_BASE}/api/token/`, { username, password })
    const { access, refresh } = response.data
    setStoredAuth(access, refresh, username)
    return { access, refresh, username }
}

export const getStoredAuth = () => {
    const token = localStorage.getItem(TOKEN_KEY)
    const refreshToken = localStorage.getItem(REFRESH_KEY)
    const username = localStorage.getItem(USER_KEY)
    return { token, refreshToken, username }
}

export const setStoredAuth = (token: string, refreshToken?: string, username?: string) => {
    localStorage.setItem(TOKEN_KEY, token)
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken)
    if (username) localStorage.setItem(USER_KEY, username)
}

export const clearStoredAuth = () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_KEY)
    localStorage.removeItem(USER_KEY)
}

export const logout = () => {
    clearStoredAuth()
}


export const getElectrolyzer = async (token: string, electrolyzer: any) => {
    const url = 'https://api.h2.damine.com.br/h2/electrolyzer/' + electrolyzer.id + '/'
    const response = await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
    const data = response.data
    return data
}

export const getDataBetween = async (date1: Date, date2: Date, electrolyzer: any, token: string) => {
    const url = 'https://api.h2.damine.com.br/h2/collect-view/?'
        + 'instant_after=' + date1.toLocaleDateString('en')
        + '&instant_before=' + date2.toLocaleDateString('en')
        // + 'instant_after=' + getStartOfDayISO(data1)
        // + '&instant_before=' + getEndOfDayISO(data2)
        + '&electrolyzer=' + electrolyzer.id
    // console.log('URL', url)
    const response = await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
    const data = response.data
    return data;

}

export const getLatestData = async (token: string, electrolyzer: any) => {
    const url = 'https://api.h2.damine.com.br/h2/collect-latest/?electrolyzer_id=' + electrolyzer.id
    const response = await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
    const data = response.data
    return data
}

export const getAvailbleDates = async (token: string, electrolyzer: any) => {
    const url = 'https://api.h2.damine.com.br/h2/datas-disponiveis/?electrolyzer=' + electrolyzer.id
    console.log('URL', url)
    const response = await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
    const data = response.data
    return data;
}

export const getElectrolyzers = async (token: string) => {
    const url = 'https://api.h2.damine.com.br/h2/electrolyzer/'
    const response = await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
    const data = response.data
    return data
}

export const updateElectrolyzerConfig = async (token: string, id: number, bt_mac: string) => {
    const url = 'https://api.h2.damine.com.br/h2/electrolyzer/' + id + '/'
    const response = await axios.patch(url,
        { bt_mac },
        { headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' } }
    )
    return response.data
}

